import React from 'react';
import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid-pro';
import { timeToString } from '../../../../src/components/library/DatePicker/DatePicker';
import { BrokerJob } from '../core';
import { ActionsCell, ServiceCell, StatusCell } from './fields';

const sharedColumnProps = {
	disableColumnMenu: true,
	disableReorder: true,
	pinnable: false,
	hideable: false,
	filterable: false,
	sortable: false,
	resizable: false,
};

const Service = "Service-Name-Column";
const Start = "Start-Column";
const End = "End-Column";
const Status = "Status-Column";
const Actions = "Actions-Column";

export function createBrokerJobsColumns(nxObjectUuid: string): GridColDef<BrokerJob>[] {
	return [
		{
			field: Service,
			headerName: 'Service',
			flex: 1,
			minWidth: 180,
			renderCell: ServiceCell,
			...sharedColumnProps,
		},
		{
			field: Start,
			headerName: 'Start',
			width: 165,
			valueFormatter: (_, row) => timeToString(new Date(row.startedAt)),
			...sharedColumnProps,
		},
		{
			field: End,
			headerName: 'End',
			width: 165,
			valueFormatter: (_, row) => (row.closedAt ? timeToString(new Date(row.closedAt)) : '---'),
			...sharedColumnProps,
		},
		{
			field: Status,
			headerName: 'Status',
			width: 168,
			renderCell: StatusCell,
			...sharedColumnProps,
		},
		{
			field: Actions,
			headerName: '',
			width: 60,
			align: 'center',
			renderCell: (params: GridRenderCellParams<BrokerJob, string>) => (
				<ActionsCell job={params.row} nxObjectUuid={nxObjectUuid} />
			),
			...sharedColumnProps,
		},
	];
}
